/* eslint-disable no-undef, react/prop-types, react/no-danger */
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { ThemeProvider } from 'emotion-theming'
import 'lazysizes'

import ResponsiveContainer from '../components/core/ResponsiveContainer'
import Footer from '../components/core/Footer'
import defaulttheme from '../constants/themeConstants/whiteTheme'
import darkTheme from '../constants/themeConstants/darkTheme'
import Header from '../components/Header'
import GalleryHome from '../components/Home/GalleryHome'
import { CloudinaryS3Image } from '../components/CloudinaryS3Image'

import {
  BlogPageContainer,
  ImageItemContainer,
  BodyLayoutContainer,
  BodyContainer
} from './albumPageStyledComponents'
import styles from './albumPageStyles.module.scss'

class Template extends React.Component {
  state = {
    isLightBoxOpen: false,
    activeNodeObject: null
  }

  openLightbox = eachImage => {
    this.setState({ isLightBoxOpen: true, activeNodeObject: eachImage })
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden'
    }
  }

  closeLightbox = () => {
    this.setState({ isLightBoxOpen: false })
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.body.style.overflow = 'unset'
    }
  }

  render() {
    const { isLightBoxOpen } = this.state
    const {
      data,
      headerPropsData,
      footerProps,
      isBookNowSlotOpened,
      bookNowModalData
    } = this.props
    if (data) {
      const { albumPageData: { edges: albumPageData } } = data

      const {
        galleryHeading,
        date,
        albumImagesList,
        albumSEOData
      } = albumPageData[0].node.frontmatter
      const {
        title,
        description,
        ogTitle,
        ogUrl,
        ogImage,
        ogDescription,
        ogType,
        ogSiteName,
        twitterTitle,
        twitterUrl,
        twitterSite,
        twitterDescription,
        twitterImage
      } = albumSEOData

      return (
        <ThemeProvider theme={defaulttheme}>
          <div>
            <Helmet>
              <title>{title}</title>
              <meta name="description" content={description} />
              <meta property="og:title" content={ogTitle} />
              <meta property="og:url" content={ogUrl} />
              <meta property="og:image" content={ogImage} />
              <meta property="og:description" content={ogDescription} />
              <meta property="og:type" content={ogType} />
              <meta property="og:site_name" content={ogSiteName} />
              <meta property="twitter:title" content={twitterTitle} />
              <meta name="twitter:url" content={twitterUrl} />
              <meta name="twitter:site" content={twitterSite} />
              <meta
                property="twitter:description"
                content={twitterDescription}
              />
              <meta name="twitter:image" content={twitterImage} />
            </Helmet>
            <BlogPageContainer className="blogImageContainer">
              <Header
                isWhite
                headerPropsData={headerPropsData}
                isBookNowSlotOpened={isBookNowSlotOpened}
                bookNowModalData={bookNowModalData}
              />
              <div>
                <div className={styles.GalleryTemplateSection}>
                  <div className={styles.headerSection}>
                    <div className={styles.headerSectionWrapper}>
                      <h1 className={styles.galleryHeading}>
                        {galleryHeading}
                      </h1>
                      <article className={styles.galleryDate}>{date}</article>
                    </div>
                  </div>
                </div>
                <ResponsiveContainer>
                  <BodyLayoutContainer>
                    <BodyContainer>
                      <div className={styles.GalleryImageContainer}>
                        {albumImagesList.map(eachImage => (
                          <ImageItemContainer
                            key={eachImage.imageUrl}
                            className={styles.ImageContainer}
                            onClick={() => this.openLightbox(eachImage)}
                          >
                            <CloudinaryS3Image
                              src={eachImage.imageUrl}
                              alt={eachImage.imageAltText}
                              draggable={false}
                              configString={'f_auto,h_175'}
                            />
                          </ImageItemContainer>
                        ))}
                      </div>

                      {isLightBoxOpen ? (
                        <GalleryHome
                          closeLightBox={this.closeLightbox}
                          currentImageData={this.state.activeNodeObject}
                          isLightBoxOpen={isLightBoxOpen}
                          totalImagesData={albumImagesList}
                          date={date}
                        />
                      ) : null}
                    </BodyContainer>
                  </BodyLayoutContainer>
                </ResponsiveContainer>
              </div>
            </BlogPageContainer>

            <Footer {...footerProps} theme={darkTheme.footerSection} />
          </div>
        </ThemeProvider>
      )
    }
  }
}

export default Template

// eslint-disable-next-line
export const pageQuery = graphql`
  query AlbumPageByPath($path: String!) {
    albumPageData: allMarkdownRemark(
      filter: { frontmatter: { path: { eq: $path } } }
    ) {
      edges {
        node {
          frontmatter {
            path
            type
            galleryHeading
            date
            albumImagesList {
              imageId
              imageUrl
              imageAltText
              shortDescription
            }
            albumSEOData {
              title
              description
              ogTitle
              ogUrl
              ogImage
              ogDescription
              ogType
              ogSiteName
              twitterTitle
              twitterUrl
              twitterSite
              twitterDescription
              twitterImage
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/album-page-template.js